<template>
  <main class="relative mx-auto w-full max-w-[10rem] min-h-screen min-h-[100svh] overflow-hidden bg-[#191e21] font-['PingFang_SC','Helvetica_Neue',Arial,sans-serif] text-white">
    <div
      class="absolute inset-0 bg-cover bg-top bg-no-repeat"
      :style="{ backgroundImage: `url(${assets.BG})` }"
      aria-hidden="true"
    ></div>

    <div class="relative z-[1] flex min-h-[100svh] flex-col px-[20px] pb-[18px]">
      <div class="pointer-events-none flex justify-center" aria-hidden="true">
        <img :src="assets.TITLE" alt="" class="mt-[100px] h-[39px] w-[226px] object-fill" />
      </div>

      <section class="mt-[195px] flex flex-1 flex-col items-center">
        <h1 class="m-0 text-center text-[20px] font-medium leading-[1.5] tracking-[0.12em] font-santi">
          欢迎使用三体 THREE-BODY<br />官方防伪验证系统
        </h1>

        <div class="mt-[18px] w-[254px]">
          <img :src="assets.SCAN" alt="" class="h-[210px] w-[254px] object-contain"  />
        </div>

        <button
          type="button"
          class="relative  h-[41px] w-full max-w-[276px] cursor-pointer border-0 bg-transparent p-0 transition hover:brightness-[1.08] active:scale-[0.98]"
          :class="{ 'pointer-events-none': scanning }"
          @click="scan"
        >
          <img v-show="!scanning" :src="assets.BUTTON" alt="扫码查询" class="block h-auto w-full" />
          <span
            v-show="scanning"
            class="absolute inset-0 flex items-center justify-center rounded-[4px] bg-white/15 text-[14px] tracking-[0.1em] text-white/80 backdrop-blur-sm"
          >
            <span class="mr-[6px] inline-block h-[14px] w-[14px] animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
            正在准备扫码…
          </span>
        </button>

        <p
          class="mt-[17px] cursor-pointer text-[16px] tracking-[0.1em] font-santi"
          @click="goIndex"
        >
          输入防伪码验证
        </p>

        <footer class="mt-[25px] flex justify-center pb-[18px]">
          <img :src="assets.BOTTOM" alt="三体宇宙" class="block h-[26px] w-[147px] object-contain" />
        </footer>
      </section>
    </div>

    <div class="absolute right-[21px] bottom-[18px] z-[1]">
      <img :src="assets.RIGHT_LOGO" alt="三体宇宙" class="block h-[9px] w-[43px] object-contain" />
    </div>
  </main>
</template>

<script>
import jsSHA from "jssha";
import axios from 'axios';
// import VConsole from 'vconsole';

// new VConsole();

const BG = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bg.png";
const TITLE = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/title_icon.png";
const BUTTON = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/btn.png";
const BOTTOM = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bottom_icon.png";
const RIGHT_LOGO = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/right_logo.png";
const SCAN = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/scan.png";

export default {
  data() {
    return {
      assets: { BG, TITLE, BUTTON, BOTTOM, RIGHT_LOGO, SCAN },
      constants: {},
      product_info: "",
      wxReady: false,
      scanning: false
    };
  },
  mounted: function() {
    this.initWechatSDK();
  },
  methods: {
    goIndex(){
      this.$router.push('/');
    },
    initWechatSDK(){
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        const script = document.createElement('script');
        script.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
        script.async = true;
        script.onload = () => {
          this.initSDK();
        };
        document.head.appendChild(script);
      } else {
        console.log('非微信环境');
      }
    },
    async initSDK() {
      if (typeof wx !== 'undefined') {
        try{
          const response = await axios.get("https://info-api.threebody.com/getJsapiTicket", { withCredentials: true });
          const ticket = response.data.ticket;

          const appId = 'wxd999582bec8e0b1f';
          const signUrl = window.__WECHAT_ENTRY_URL__ || location.href.split('#')[0];
          const config = this.sign(ticket, signUrl)
          wx.config({
            debug: false,
            appId: appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature,
            jsApiList: ['scanQRCode']
          });

          // 只注册一次，config 注入完成后 wx 自动触发
          wx.ready(() => {
            this.wxReady = true;
            // 强制触发 scanQRCode 在线权限校验，修复 iOS 高版本 "offline verifying" 问题
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: (res) => {
                console.log('[checkJsApi] scanQRCode 校验结果:', res);
              }
            });
          });

          wx.error((res) => {
            alert('[微信SDK初始化失败] ' + JSON.stringify(res));
          });
        }catch(e){
          console.error("[initSDK] 微信JS-SDK加载失败", e);
          alert('[微信SDK加载失败] ' + (e && e.message ? e.message : JSON.stringify(e)));
        }
      } else {
        console.error('[initSDK] 微信JS-SDK加载失败，wx 未定义');
        alert('[微信SDK加载失败] wx 未定义');
      }
    },
    scan(){
      let that = this;
      if (!this.wxReady) {
        this.scanning = true;
        const start = Date.now();
        const check = setInterval(() => {
          if (this.wxReady) {
            clearInterval(check);
            this.scanning = false;
            that.doScan();
          } else if (Date.now() - start > 5000) {
            clearInterval(check);
            this.scanning = false;
            alert("扫码功能初始化失败，请刷新页面重试");
          }
        }, 200);
        return;
      }
      that.doScan();
    },
    doScan(){
      let that = this;
      // iOS 高版本在 wx.ready 回调里调用 scanQRCode，可绕开部分离线校验失败的场景
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ['qrCode'],
          success: async function (res) {
            let scanResult = res.resultStr;
            let code = that.getQueryParam(scanResult);
            if(code && code !== "未找到参数"){
              let product_info = await that.getProductInfo(code)
              if(product_info !== ""){
                that.$router.push({
                  path: "/productInfo",
                  query: {
                    value: product_info
                  }
                });
              }else{
                alert("未查询到产品信息，请确认防伪码正确");
              }
            }else{
              alert("无效的二维码，请扫描正确的防伪二维码");
            }
          },
          fail: function(res) {
            console.error("扫码失败fail:", res);
            alert("扫码失败，请重试");
          },
          cancel: function(res) {
            console.log("扫码取消:", res);
          },
          complete: function(res) {
            console.log("扫码完成:", res);
          }
        });
      });
    },
    getQueryParam(url_value) {
      console.log("解析扫码结果:", url_value);
      if (url_value.includes("cj8.ren")) {
        try {
          let url = new URL(url_value);
          return url.search.slice(1);
        } catch (e) {
          console.error("解析短链接失败:", e);
          return "";
        }
      }

      if (url_value.includes("test-verify.3body.com") || url_value.includes("verify.3body.com")) {
        try {
          let url = new URL(url_value);
          return url.search.slice(1);
        } catch (e) {
          console.error("解析验证链接失败:", e);
          return "";
        }
      }

      // 兜底：尝试通用提取
      try {
        let url = new URL(url_value);
        if (url.search) {
          return url.search.slice(1);
        }
      } catch (e) {
        let match = url_value.match(/[?&]([^?&#]+)$/);
        if (match) {
          return match[1];
        }
      }

      return "未找到参数";
    },
    async getProductInfo(code) {
      try {
        let response = await axios.post("https://info-api.threebody.com/anti/router", {
          code: code
        });
        if (response.status === 200 && response.data.IsSuccess) {
          return response.data.ResponseData;
        } else {
          console.warn('[getProductInfo] 接口返回失败:', response.data);
          return "";
        }
      } catch (error) {
        console.error('[getProductInfo] 接口异常:', error);
        return "";
      }
    },
    sign(jsapi_ticket, url) {
      let ret = {
        jsapi_ticket: jsapi_ticket,
        nonceStr: this.createNonceStr(),
        timestamp: this.createTimestamp(),
        url: url
      };
      let string = this.raw(ret);
      let shaObj = new jsSHA("SHA-1", 'TEXT');
      shaObj.update(string);
      ret.signature = shaObj.getHash('HEX');
      return ret;
    },
    createNonceStr() {
      return Math.random().toString(36).substr(2, 15);
    },
    createTimestamp() {
      return parseInt(new Date().getTime() / 1000) + '';
    },
    raw(args) {
      let keys = Object.keys(args);
      keys = keys.sort()
      let newArgs = {};
      keys.forEach(function (key) {
        newArgs[key.toLowerCase()] = args[key];
      });

      let string = '';
      for (let k in newArgs) {
        string += '&' + k + '=' + newArgs[k];
      }
      string = string.substr(1);
      return string;
    },
  }
};
</script>

<style>
@media (min-width: 751px) {
  body {
    background: #0d1012;
  }
}
</style>
